import styled from 'styled-components'

export const InlineSvg = styled.svg`
  display: inline-block;
  color: inherit;
  fill: currentColor;
`
